import { GeneralSetting } from '@apis'
import { Button, Card, Row } from '@components'
import Fields from '@components/fields'
import { cardStyle, StyleColumn } from '@components/styles'
import { EditorSchema } from '@validations'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'

interface AdminDefaultEditorFormProps {
  pageKey: string
  title: string
  data: any
}

const AdminDefaultEditorForm = ({
  pageKey,
  title,
  data,
}: AdminDefaultEditorFormProps) => {
  const [loading, setLoading] = useState(false)
  const [initialValues, setInitialValues] = useState({
    key: pageKey,
    value: '',
  })

  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload = {
      ...values,
      title: title,
    }

    try {
      if (data?.value && data?.id) {
        await GeneralSetting.update(pageKey, payload, data?.id)
      } else {
        await GeneralSetting.create(pageKey, payload)
      }
    } catch (error) {
      console.error('Error during save:', error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (!!data?.id) {
      setInitialValues({
        ...initialValues,
        value: data?.value,
      })
    }
  }, [data?.id])

  return (
    <>
      <Card customStyle={cardStyle}>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={EditorSchema.editorValidation}
          onSubmit={submitHandler}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <StyleColumn>
                <Fields.Editor name="value" />
                <Row justifyContent="flex-end">
                  <Button
                    title="Save"
                    loading={loading}
                    type="submit"
                    height={40}
                  />
                </Row>
              </StyleColumn>
            </Form>
          )}
        </Formik>
      </Card>
    </>
  )
}

export default AdminDefaultEditorForm
